import { get, post, deletes, put } from './index' //导入axios实例文件中方法
import { url } from './index'

const map = {
  jiaoyu: 'education', // 教育
  peixun: 'training', // 培训
  rongzi: 'finance', // 融资
  touzi: 'investment', // 投资
  zhaoshang: 'attractInvestment', // 招商
  jiameng: 'joinIn', // 加盟
  zufang: 'rentHouse', // 租房
  shoufang: 'saleHouse', // 售房
  qiche: 'car', // 汽车
  jiaoyou: 'friends', // 交友
  gouwu: 'shop', // 购物
  meishi: 'food', // 美食
  lvyou: 'tour', // 游乐
  jiankang: 'health', // 健康

  zhaopin: 'jobUpdate', // 招聘
  gwxxgxqkb: 'jobUpdate', // 招聘
  qiuzhi: 'qiuzhi', // 求职
  lvshi: 'layer', // 律师
  xinwen: 'chenjNews', // 新闻

  zixun: 'law/service', // 咨询
  weituo: 'case/entrust', // 委托

  wenzhang: 'global/news', // 全局文章
  pinglun: 'comments', // 评论
  tousu: 'complaint', // 投诉建议
  hudong: 'onlineMessage', // 互动交流
  shoucang: 'favourite', // 收藏
  lvshisq: 'layerApply', // 律师申请
  mianshi: 'interview', // 面试邀请
  jianli: 'receiveResume', // 投递简历

  qiyesq: 'apply/to/organization', // 企业申请
  banner: 'carousel', // 轮播图
  leaderbox: 'leaderBox', // 领导信箱

  quickqiuzhi: 'quick/find/job', // 快速求职
  qiye: 'task/to/organization', // 企业

  shengting_qiye: 'sync/company', // 企业信息
  shengting_gangwei: 'sync/job', // 岗位信息
  shengting_zhaopinhui: 'sync/hire', // 招聘会信息
  shengting_zhaopingangwei: 'sync/hire/job', // 招聘会招聘岗位信息

  vip: 'vip', // vip
  guanggao: 'adc', // 广告

  hetong: 'contract', // 合同
  mianshihui: 'interview/invite', // 合同面试会
  mianshihuifankui: 'interview/feedback', // 合同面试会反馈
  fapiao: 'invoice', // 发票

  zhan_song: 'send/site/service', // 送站
  zhan_jie: 'take/site/service', // 接站
  zhan_liuyan: 'site/message', // 站内消息

  gongzi: 'salary', // 工资

  shebao_geren: 'personInsuranceBaseInfo', // 个人社保
  shebao_weizhuanyi: 'untransfer', // 未转移社保名单
  shebao_bujiaofei: 'addPayment', // 补缴费
  shebao_jiaona: 'insurance', // 缴纳情况查询
  shebao_tuifei: 'insuranceYear', // 社保退费

  rlzy_guanlian_qiye: 'cooperateOrganization', // 关联企业
  rlzy_guanlian_geren: 'cooperateUser', // 关联个人
  rlzy_guanlian_hetong: 'organizationContract', // 关联企业 合同
  rlzy_dengji_hesuan: 'gift', // 费用核算发放登记
  rlzy_dengji_kaipiao: 'invoice/out', // 开票登记
  rlzy_dengji_daozhang: 'income', // 到账登记

  jzgd_yonggongbeian: 'laborRecord', // 劳动用工备案
  jzgd_zaixianqiuzhu: 'onlineHelp', // 在线求助

  vipsq: 'applyVip', // VIP申请

  yz_wt_weituo: 'entrustContract', // 委托合同
  yz_wt_fapiao: 'entrust/invoice', // 发票申领
  yz_tj_tiaojie: '', // 调解申请
  yz_ss_baoquan: '', // 诉讼保全
  yz_ss_qubaohoushen: '', // 取保候审
  yz_ss_gongzheng: '', // 公证鉴定
  yz_ss_jinzhan: 'litigationProgress', // 诉讼进展
  yz_ws_zhengju: 'litigationDoc', // 证据资料上传
  yz_ws_caijue: 'litigationDoc', // 裁判文书上传
  yz_ws_zongjie: 'litigationDoc', // 案件总结上传
  yz_ws_guidang: 'litigationDoc', // 案件资料归档

  report: 'poorLabor/sub/report', // 报表

  subsite: 'area/subsite', // 站点

  questionnaire_jionCity: 'invest', // 人口进城求职调查
  questionnaire_log: 'service/log', // 问卷调查-服务日志

  canjiren_jynldwjycjrzkdcb: 'deformed/man', // 就业年龄段未就业残疾人状况调查表
  tuiyijunren_tyjrjyqkcjb: 'veteransJob', // 退役军人就业情况采集表

  yiliaofuwu_bqhf: 'follow/up/calling', // 病人
  yiliaofuwu_thjl: 'follow/up/calling/history', // 通话记录
  yiliaofuwu_btsz: 'site/setting', // 表头设置
  yiliaofuwu_hjxtpz: 'follow/up/calling/config', // 呼叫系统配置
}

function url_create(str) {
  switch (str) {
    case 'questionnaire_jionCity':
    case 'quickqiuzhi':
    case 'subsite': return `/${map[str]}`
    default: return `/user/${map[str]}`
  }
}
function url_delete(str) {
  switch (str) {
    case 'subsite': return `/${map[str]}`
    default: return `/user/${map[str]}`
  }
}
function url_modify(str) {
  switch (str) {
    case 'wenzhang': return '/user/global/news'
    case 'subsite': return `/${map[str]}/modify`
    default: return `/user/${map[str]}/modify`
  }
}
function url_search(str) {
  switch (str) {
    case 'gwxxgxqkb': // 招聘
    case 'weituo': // 委托
    case 'qiye': // 企业管理

    case 'shengting_qiye': // 企业信息
    case 'shengting_gangwei': // 岗位信息
    case 'shengting_zhaopinhui': // 招聘会信息
    case 'shengting_zhaopingangwei': // 招聘会招聘岗位信息

    case 'hetong': // 合同
    case 'mianshihui': // 合同面试会
    case 'mianshihuifankui': // 合同面试会反馈
    case 'fapiao': // 发票

    case 'zhan_song': // 送站
    case 'zhan_jie': // 接站
    case 'zhan_liuyan': // 站内消息

    case 'gongzi': // 工资

    case 'shebao_geren': // 个人社保
    case 'shebao_weizhuanyi': // 未转移社保名单
    case 'shebao_bujiaofei': // 补缴费
    case 'shebao_jiaona': // 缴纳情况查询
    case 'shebao_tuifei': // 社保退费

    case 'hudong': // 互动交流

    case 'rlzy_guanlian_qiye': // 关联企业管理
    case 'rlzy_guanlian_geren': // 关联个人管理
    case 'rlzy_guanlian_hetong': // 关联合同管理
    case 'rlzy_dengji_hesuan': // 费用核算发放登记
    case 'rlzy_dengji_kaipiao': // 开票登记
    case 'rlzy_dengji_daozhang': // 到账登记

    case 'jzgd_yonggongbeian': // 劳动用工备案
    case 'jzgd_zaixianqiuzhu': // 在线求助

    case 'yz_wt_weituo': // 委托合同
    case 'yz_wt_fapiao': // 发票申领
    case 'yz_tj_tiaojie': // 调解申请
    case 'yz_ss_baoquan': // 诉讼保全
    case 'yz_ss_qubaohoushen': // 取保候审
    case 'yz_ss_gongzheng': // 公证鉴定
    case 'yz_ss_jinzhan': // 诉讼进展
    case 'yz_ws_zhengju': // 证据资料上传
    case 'yz_ws_caijue': // 裁判文书上传
    case 'yz_ws_zongjie': // 案件总结上传
    case 'yz_ws_guidang': // 案件资料归档

    case 'report': // 报表

    case 'questionnaire_jionCity': // 人口进城求职调查
    case 'questionnaire_log': // 问卷调查-服务日志

    case 'yiliaofuwu_bqhf': // 病人
    case 'yiliaofuwu_thjl': // 通话记录
    case 'yiliaofuwu_btsz': // 表头设置
    case 'yiliaofuwu_hjxtpz': // 呼叫系统配置
      return `/user/${map[str]}`
    default: return `/${map[str]}`
  }
}
function url_export(str) {
  switch (str) {
    case 'shebao_weibanli': return `/user/insuranceYear/unpaylist/export`
    case 'shebao_tuifei2': return `/user/personInsuranceBaseInfo/return`
    case 'gwxxgxqkb': return `/user/jobUpdate/data/export`
    case 'questionnaire_jionCity': return `/invest/export`
    default: return `/user/${map[str]}/export`
  }
}
function url_import(str) {
  switch (str) {
    case 'shebao_jiaona': return `/user/insurance/conform/import`
    case 'questionnaire_jionCity': return `/invest/import`
    default: return `/user/${map[str]}/import`
  }
}

export const API = {
  baseUrl: url,
  imgUrl: url,
  imgUrl_: url + '/user/img/',
  url_upload: url + '/user/upload',
  url_upload_pu: url + '/user/public/upload',
  url_upload_pr: url + '/user/private/upload',
  url_import: url_import,

  util_create: (str, data) => post(url_create(str), data),
  util_modify: (str, data) => put(url_modify(str), data),
  util_delete: (str, data) => deletes(url_delete(str), data),
  util_search: (str, data) => put(url_search(str), data),
  util_export: (str, data) => put(url_export(str), data),

  // 企业数量查询
  company_number_search: data => put('/user/jobUpdate/count', data),

  // 站点查询
  position_search: data => put('/area/site', data),

  // 给工作人员分配人员服务范围 | userId | areaId | startNo | endNo
  // userId:给哪一个工作人员分配，areaId,在哪个区域里面给这个工作人员分配，startNo分配的起始位置，endNo分配的结束位置，startNo和endNo是闭区间"
  assign_user: data => post('/user/assign/user', data),
  // 给工作人员分配企业服务范围 | userId | areaId | startNo | endNo
  assign_organization: data => post('/user/assign/organization', data),

  // 浏览次数
  getViewNumber: data => put('/site/view/time', data),
  // 在线求助 (验证码)
  zaixianqiuzhu_create: (data, phone, code) => post(`/user/onlineHelp/${phone}/${code}`, data),

  // #region 用户
  // 用户重置密码
  _user_forget: (phone, code, password) => put(`/reset/password`, { phone, code, password }),
  // 用户登录
  _user_login: (name, password) => put(`/login`, { name, password }),
  // 发送验证码
  _user_SendCode: data => put(`/random/phone/code`, data),
  // 注册单位或个人用户
  _user_register: (phone, code, data) => put(`/register/`+phone+'/'+code, data),
  // 单位或个人用户修改自身基本信息
  _user_modify: data => put('/user/modify', data),
  // 查询用户个人信息
  _user_userInfo: id => put('/user/userInfo', {id}),
  // #endregion

  // 通过企业名称查询企业账户信息
  _user_companyInfo: (data ={}) => put('/userName', data),
  // 个人账户转企业账号 | userId | o_name | o_img | status
  user_apply_company: data => put('/user/apply/to/organization', data),

  // #region 站点
  //创建站点
  createSubsite: data => post('/area/subsite', data),
  //查询站点
  getSubsite: (data = {}) => put('/area/subsite', data),
  //修改站点
  editSubsite: data => put('/area/subsite/modify', data),
  //删除站点
  deleteSubsite: ids => deletes('/area/subsite', {ids}),
  // #endregion

  // #region 用户
  //查询用户
  getUserList: (data = {}) => put('/user/user', data),
  //修改用户
  editUserList: data => put('/user/modify', data),
  //创建用户
  createUserList: data => post('/user/user', data),
  //删除用户
  deleteUser: ids => deletes('/user/user', {ids}),
  // #endregion

  // #region 角色
  //创建角色
  createRole: data => post('/user/role', data),
  //修改角色
  editRole: data => put('/user/role/modify', data),
  //删除角色
  deleteRole: ids => deletes('/user/role', {ids}),
  //查询角色
  getRole: (data={}) => put('/role', data),
  // #endregion

  // #region 评价
  //创建评价
  createComment: data => post('/user/comments', data),
  //查询评价
  getComment: (data = {}) => put('/comments', data),
  // #endregion

  //修改用户
  editUserTopping: data => put('/user/show/modify', data),

  //修改系统设置
  editSystemNameLogo: data => put('/user/system/setting/modify', data),
  // 用户注销
  _user_cancellation: () => put(`/loginout`),
  // 修改方法
  change: (url, data) => put(`${url}`, data),
  // 创建方法
  create: (url, data) => post(`${url}`, data),
  // 查询方法
  getData: (url, data) => put(`${url}`, data),
  // 获取公共文件的url
  getPublicFileUrl: () => get('/public/bucketEndpoint'),
  // 解表导出
  download_doc: id => {
    var iframe = document.createElement('iframe')
    iframe.style.display = 'none';
    iframe.src = `${url}/user/download/${id}`;
    console.log(iframe.src)
    document.body.appendChild(iframe);
  },
  // 文件删除
  delete_files: ({ url, data = {} } = {}) => deletes(`${url}`, data),
  // 请求地址
  getPlace: data => put(`/area/get`, data),
  // 编辑地址
  changePlace: data => put(`/area/name`, data),
  // 查询当前用户的登录状态
  get_user_login_info: () => put(`/user/userInfo`),
  // 创建服务日志
  createLog: data => post(`/user/helpLog`, data),
  // 查询服务日志
  getlog: data => put(`/user/helpLog`, data),
  // 创建分站管理员
  createSubAdmin: data => post(`/user/subAdmin`, data),
  // 获取创建的用户
  getUsers: (url, data) => put(`${url}`, data),
  // 创建普通管理
  createCommonAdmin: data => post(`/user/commonAdmin`, data), 
  // 根据地区查nam
  getPlaceName: data => put(`/area`, data),
  // 获取每个点对应的数据
  get_map_data: data => put(`/user/poorLabor/area`, data),

  // 通过ID查询地区 // map
  get_area_info: data => put(`/area`, data),
  // 获取下级城市列表 // map
  get_Regional_information: data => put(`/area/get`, data),
  // 人口总数 // map
  mapSummation: data => put(`/user/poorLabor/report`, data),
  // 查询每个地区对应的图片id // map
  get_img_id: ({ id }) => get(`/system/setting/${id}`),
  // 点击进度条 查询滚动条
  get_swiper_data: data => put(`/user/poorLabor`, data),

  // 查询目标日志
  getTargetLog: data => put(`/user/helpLog/target`, data),
  // 查询自己得日志
  getMyLog: data => put(`/user/helpLog/self`, data),
  // 设置权限
  // setPower: data => put(`/user/privilege`, data),
  // 查询要导出文件得id
  getExport: (url, data) => put(`${url}`, data),
  downloadTable: url => get(`${url}`),
  // 查看单个图片
  see_img: ({ id }) => `${url}/user/img/${id}`,
  // 获取上级城市信息
  getFather: data => put(`/area/list`, data),
  // 需求关系查询
  needsRecruitment: ({ areaId, salaryType = 1, ageType = 1, educationType = 1 } = {}) => put(`/user/recruitUnit/search`, { areaId, salaryType, ageType, educationType }),
  // 供求结构体系
  get_Supply_and_demand_structure: ({ areaId, salaryType, ageType, educationType, areaType }) => put(`/user/recruitUnit/search/bytime`, { areaId, salaryType, ageType, educationType, areaType }),
  // 供求结构体系
  poorLabor_Supply_and_demand_structure: ({ areaId, salaryType, ageType, educationType, areaType }) => put(`/user/poorLabor/search/bytime`, { areaId, salaryType, ageType, educationType, areaType }),
  // 设置政策链接
  setLink: data => put(`/user/system/setting/policyurl`, data),
  // 设置人社业务
  setRSLink: data => put(`/user/system/setting/socialUrl`, data),
  // 查询分站系统配置
  getSystem: id => get(`/system/setting/${id}`),
  // 设置分站系统配置
  setSystem: (id, data) => put(`/user/system/setting/${id}`, data),
  // 设置标题
  setTitle: data => put(`/user/system/setting/title`, data),
  // 设置地图描述信息
  setDesc: data => put(`/user/system/setting/showDesc`, data),
  // 查询自己的帮扶对象
  getSelfHelp: () => put(`/user/helpCP/self`),
  // 设置地图显示人口数
  setMapInfo: data => put(`/user/system/setting/personInfo`, data),
  // 设置地图图片
  setMapImg: data => put(`/user/area/show/img`, data),
  // 修改别人的密码
  changeOrtherPass: data => put(`/user/other/password`, data),
  // 获取已开通合作的城市列表
  getScreen: data => put(`/area/subSite`, data),
  // 按用户名搜索用户
  searchName: name => put(`/user/user`, { name }),
  // 上传系统logo
  setFenZhanLogo: (id, logoId) => put(`/user/system/setting/logo`, { id, logoId }),
  // 添加报表数据
  report_fix: data => put(`/user/poorLabor/report/fix`, data),
  // 获取下载文件id
  templateDown: data => put(`/template`, data),


  deleteData: (api, ids) => deletes(`${api}`, { ids }),
  // 修改帮扶对象密码
  changeHelpPass: (phone, password) => put(`/user/helpCP/modify/password`, { phone, password }),
  // 修改地区名称
  changeArea: (id, name) => put(`/area/modify/name`, { id, name }),
  // 修改地区经纬度
  changeAreaLng: (id, lnglat) => put(`/area/modify/lnglat`, { id, lnglat }),
  // 创建地区
  createArea: (parent_id, name) => post(`/area/add`, { parent_id, name }),
  // 删除地区
  deleteAreaLng: id => deletes(`/area/delete`, { id }),


  // 查询家庭成员
  family: residenceNo => put(`/user/helpCP/residence`, { residenceNo }),

  // 个人信息
  selfInfo: data => put(`/user/self/userInfo`, data),

  // 上传培训文件
  uploadFile: () => post(`/user/upload`),
  // 子节点培训设置
  setChildStudy: (id, trainingId) => put(`/user/system/setting/training`, { id, trainingId }),
  // 创建培训申请
  createStudy: data => post(`/user/training/apply`, data),
  // 查询培训申请
  getStudyApply: (pageNumber, status, areaId) => put(`/user/training/apply`, { pageNumber, status, areaId }),
  // 修改培训申请
  editStudy: data => put(`/user/training/apply/modify`, data),

  // 查询就业地图
  job_map_get: areaId => put(`/user/jobUpdate/plan/persons`, { areaId }),
  // 通过ID查询招聘信息
  jobInfo: id => put(`/user/jobUpdate/query`, { id }),
  // 修改个人所属地区
  userInfoChange: (id,areaId) => put(`/user/areaId`, { id,areaId }),


  //看了此职位的人还会看
  getSuggestJob: (id) => put('/jobUpdate/suggestJob', {id}),

  //查询全局配置
  getGlobalSetting: (data={}) => put('/globalSetting', {data}),
  //修改全局配置/user/globalSetting/modify
  editGlobalSetting: data => put('/user/globalSetting/modify', data),

  //下载用户简历
  downloadResume: data => put('/user/download/receiveResume', data),
  // 修改求职
  // editinterview: data => put('/user/interview/modify', data),
  // // 删除求职
  // deleteinterview: (ids) => deletes('/user/interview', {ids}),

  // 查询用户   ---求职
  getqiuzhi: (data = {}) => put('/qiuzhi', data ),
  // 查询求职
  getJobWanted: (data = {}) => put('/qiuzhi', data ),

  // #region 10.12 s
  // 设置vip
  setVip: data => put('/user/vip', data),
  // 企业合同电子签约 id
  signContract: data => put('/user/company/contract', data),
  // 面试邀请电子签约 id
  signInterview: data => put('/user/interview/invite/signature', data),
  // 面试反馈电子签约 id
  signFeedback: data => put('/user/interview/feedback/signature', data),
  // #endregion

  // 地图报表
  report_get : data => put('/user/poorLabor/report/real', data),

  // #region 问卷调查
  // 查询地区对应的户籍地址
  getQuestionnaireJionCityAreas: data => put('/invest/address', data),
  // 查询地区对应的楼盘
  getQuestionnaireJionCityBuildings: data => put('/invest/house', data),
  // #endregion

  // #region 医疗服务
  // 获取TCCC url
  getTCCCUrl: () => put('/user/follow/up/calling/token', {}),
  // 保存呼出记录
  addCallOutHistory: data => put('/user/follow/up/calling/create/history', data),
  // 保存呼入记录
  addCallInHistory: data => put('/user/follow/up/incoming/create/history', data),
  // 座席用户
  // seatTest: data => put('/user/follow/up/calling/seat/test', data),
  // 下载通话文件
  downloadCallHistory: data => put('/user/follow/up/calling/history/voice/file', data),
  // 呼叫统计
  callReport: data => put('/user/follow/up/calling/report', data),
  // 查询所有通话记录
  getAllCallHistory: data => put('/user/follow/up/calling/history/list', data),
  // 设置协作人服务人数
  assignPersonCount: data => put('/user/follow/up/calling/assign', data),
  // 设置协作人服务人数
  transferPersonCount: data => put('/user/follow/up/calling/transfer', data),
  // #endregion
}